export const FILTERS = {
  action: "Actions",
  view: "Viewed Job",
  status: "Status Change",
  edit: "Edit",
  smsCall: "SMS / Call",
  email: "Email",
} as const;

export const FILTER_EVENT_MAP: Record<keyof typeof FILTERS, { event: string[]; event_name?: string[] }> = {
  action: { event: ["action", "driver", "cancelled", "close"] },
  view: { event: ["view"] },
  status: { event: ["status"] },
  edit: { event: ["edit", "admin"] },
  smsCall: { event: ["notification"], event_name: ["sms", "voice"] },
  email: { event: ["notification"], event_name: ["email"] },
};
